// This file is generated.
export const version = '2.0.0'
